import {isIdCard} from './validate'

/**
 * 三阴图片处理
 * @param imgStr 三阴图片str
 * @param flag 是否是保存
 */
export const formatteThreeConditionImages = (imgStr, flag = false) => {
    if (!imgStr) return []
    const arr = imgStr.split(',')
    if (flag) {
        return [...arr.slice(1, 3), ...arr.slice(-1), ...arr.slice(0, 1)]
    } else {
        return [...arr.slice(-1), ...arr.slice(0, arr.length - 1)]
    }
}

/**
 * 根据出生日期算年龄
 * @param {*} birthday
 * @returns number
 */

export function ageTimeFormat(birthday) {
    if (!birthday) return 0

    const nowDate = new Date()
    birthday = new Date(birthday)
    const currentYear = nowDate.getFullYear() //当前的年份
    const birthdayYear = birthday.getFullYear() //计算的年份

    const currentMonth = nowDate.getMonth()
    const birthdayMonth = birthday.getMonth()

    const currentDate = nowDate.getDate()
    const birthdayDate = birthday.getMonth()

    if (currentYear === birthdayYear) return 0
    if (
        currentMonth > birthdayMonth ||
        (currentMonth === birthdayMonth && currentDate >= birthdayDate)
    )
        return currentYear - birthdayYear
    else return currentYear - birthdayYear - 1
}

/**
 *  根据身份证计算年龄 性别
 * @param idCard string
 * @returns age 年龄 sex 性别
 */
export function getIdCardInfo(idCard) {
    if (!idCard) {
        return {
            sex: '未知',
            age: 0
        }
    }
    const sex = isIdCard(idCard)
        ? parseInt(idCard.substring(16, 17)) % 2 == 1
            ? '男'
            : '女'
        : '未知'
    const age = ageTimeFormat(
        `${idCard.substring(6, 10)}/${idCard.substring(10, 12)}/${idCard.substring(
            12,
            14
        )}`
    )
    return {
        sex,
        age
    }
}

export function analyzeIDCard(IDCard) {
    let sex
    let birthday = ''
    //获取用户身份证号码
    //获取性别
    if (parseInt(IDCard.substr(16, 1)) % 2 == 1) {
        sex = 1 //男
    } else {
        sex = 0 //女
    }
    //获取出生年月日
    const yearBirth = IDCard.substring(6, 10)
    const monthBirth = IDCard.substring(10, 12)
    const dayBirth = IDCard.substring(12, 14)
    birthday = yearBirth + '-' + monthBirth + '-' + dayBirth
    //返回性别和年龄
    return {birthday, sex}
}

export function askDrugPackCount(row) {
    // 包装计算
    const quantity = row.quantity;
    let whole = ""; // 整
    let remainder = ""; // 零
    let lack = false; // 缺
    let total = quantity; // 总量
    let name = ""; // 显示值
    if (quantity) {
        if (row.packingScale && row.packingScale != 1) {
            // 计算包装
            if (row.isPackingSale) {
                // 整装
                let int = Math.ceil(quantity / row.packingScale);
                whole = `${int}${row.unit}`;
                if (int * row.packingScale > quantity) {
                    lack = true;
                }
                total = int * row.packingScale;
            } else {
                // 部分包装
                let int = Math.floor(quantity / row.packingScale);
                if (int > 0) whole = `${int}${row.unit}`;
                let float = quantity % row.packingScale;
                if (float > 0) {
                    // 余数
                    remainder = `${float}${row.dosageUnitName}`;
                }
            }
        } else {
            // 散装
            remainder = `${quantity}${row.dosageUnitName}`;
        }
        name = [whole, remainder].join("");
    }
    return {
        whole,
        remainder,
        lack,
        total,
        name,
    };
}


export function base64ToFile(base64, filename) {
    const arr = base64.split(',');
    const mime = arr[0].match(/:(.*?);/)[1];
    const bstr = atob(arr[1]);
    let n = bstr.length;
    const u8arr = new Uint8Array(n);
    while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
    }
    return new File([u8arr], filename, {type: mime});
}
// 复制到剪切板
export function copyToClipboard(text) {
    var textarea = document.createElement('textarea');
    textarea.style.position = 'fixed';
    textarea.style.opacity = 0;
    textarea.value = text;
    document.body.appendChild(textarea);
    textarea.select();
    document.execCommand('copy');
    document.body.removeChild(textarea);
    this.$toast("复制成功");

}
